<template>
  <div>
    <div class="empInfoBox">
      <div class="leftBox">
        <div class="userIconBox">
          <div
            class="avatarBox"
            :style="'background-image:url(' + empInfo.avatar + ')'"
          ></div>
        </div>
      </div>
      <div class="middleBox">
        <div class="empName">{{ empInfo.name }}</div>
        <!-- <div class="empCompanyName">{{ empInfo.corporateName }}</div> -->
        <div class="empCompanyName">招商信诺人寿保险有限公司</div>
        <div
          class="practiceTitle"
          style="margin-bottom: 3px"
          v-show="empInfo.practiceNumber"
        >执业证<span style="margin-left: 5px">{{empInfo.practiceNumber}}</span>
        </div>
        <!-- <div class="empCompanyName">{{ empInfo.practiceNumber }}</div> -->
        <!-- <div class="practiceTitle" style="margin-bottom: 3px">12345678901234567890123456</div> -->
      </div>
      <div
        class="rightBox"
        @click="showQRcodeMask = true"
      >
        <div class="wxWorkIcon"></div>
        <div class="wxWrokText">微信</div>
      </div>
      <div
        v-show="isShow"
        class="btn"
      >
        <div
          class="big"
          v-show="flag"
        >
          <div
            class="big_1"
            @click="btnBig"
          >
            <div class="shrink">收 缩</div>
            <img src="../assets/images/insarrow.png" />
          </div>
          <div class="big_2">
            <span>阅读 {{ formData.browseTimes}}</span>
            <div
              class="good"
              @click="btnImg"
            >
              <img
                v-if="showImg"
                src="../assets/images/noGood.png"
              />
              <img
                v-else
                src="../assets/images/Good.png"
              />
              <div class="text">{{list.totalLikes}}</div>
            </div>
          </div>
        </div>
        <div
          class="small"
          v-show="!flag"
          @click="btnSmall"
        >
          <div class="unfold">展 开</div>
          <img src="../assets/images/insarrow-180.png" />
        </div>
      </div>

    </div>

    <div
      class="showQRcodeMask"
      v-show="showQRcodeMask"
      @click="showQRcodeMask = false"
    >
      <div
        class="qrcodeInfoBox"
        @click.stop
      >
        <div class="qrcodeEmpInfoBox">
          <div class="leftBox">
            <div class="userIconBox">
              <div
                class="avatarBox"
                :style="'background-image:url(' + empInfo.avatar + ')'"
              ></div>
            </div>
          </div>
          <div class="middleBox">
            <div class="empName">{{ empInfo.name }}</div>

            <div class="empCompanyName">招商信诺人寿保险有限公司</div>
            <div
              class="practiceTitle"
              style="margin-bottom: 3px"
              v-show="empInfo.practiceNumber"
            >
              执业证<span
                style="margin-left: 5px">{{empInfo.practiceNumber}}</span>
            </div>
          </div>
          <div
            class="shadowBox"
            v-show="!empInfo.practiceNumber"
          ></div>
        </div>
        <div class="qrcodeImg">
          <img
            :src="empInfo.contactWayQrcode"
            alt=""
          />
        </div>
        <div class="qrcodeText">请长按二维码添加或联系客户经理</div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { getTotalLikes, saveOrCancelLikes } from "../services/share-pages.js"
export default {

  props: {
    empInfo: {
      type: Object,
      default: () => {
        return {

        };
      },
    },
  },
  data () {
    return {
      showQRcodeMask: false,
      flag: true,
      showImg: true,
      list: {},
      formData: {},
      isShow: true
    };
  },
  created () {
    const query = qs.parse(window.location.search.slice(1));
    this.formData = JSON.parse(window.localStorage.getItem('formData'));
    const type = window.location.search.slice(1);
    // console.log("type",type);
    if (type.indexOf("code") != -1) {
      this.isShow = true;
      return getTotalLikes({
        ticket: query.ticket,
        activityId: query.activityId,
        // unionId: 'oSWTisrBhmQvvsO0q5nFN46USQr4'
        unionId: this.formData.unionId
      }).then(data => {
        this.list = data
        if (this.list.isLike) {
          this.showImg = false;
        } else {
          this.showImg = true;
        }
        if (this.list.totalLikes >= 10000) {
          let strNumber = this.list.totalLikes.toString()
          let num = strNumber.slice(0, 1);
          if (strNumber.length == 8) {
            this.list.totalLikes = `${num}000万+`
          } else if (strNumber.length == 7) {
            this.list.totalLikes = `${num}00万+`
          } else if (strNumber.length == 6) {
            this.list.totalLikes = `${num}0万+`
          } else {
            this.list.totalLikes = `${num}万+`
          }
        } else {
          return this.list
        }
      })
    } else {
      this.isShow = false;
    }
    if (this.formData.browseTimes >= 100 && this.formData.browseTimes < 1000) {
      let strNumber = this.formData.browseTimes.toString()
      let num = strNumber.slice(0, 1);
      this.formData.browseTimes = `${num}百+`
    } else if (this.formData.browseTimes >= 1000 && this.formData.browseTimes < 10000) {
      let strNumber = this.formData.browseTimes.toString()
      let num = strNumber.slice(0, 1);
      this.formData.browseTimes = `${num}千+`
    } else if (this.formData.browseTimes >= 10000) {
      let strNumber = this.formData.browseTimes.toString()
      let num = strNumber.slice(0, 1);
      if (strNumber.length == 8) {
        this.formData.browseTimes = `${num}000万+`
      } else if (strNumber.length == 7) {
        this.formData.browseTimes = `${num}00万+`
      } else if (strNumber.length == 6) {
        this.formData.browseTimes = `${num}0万+`
      } else {
        this.formData.browseTimes = `${num}万+`
      }
    } else {
      return this.formData
    }
  },
  methods: {
    btnBig () {
      this.flag = false
    },
    btnSmall () {
      this.flag = true
    },
    btnImg () {
      const query = qs.parse(window.location.search.slice(1));
      // console.log("query-174", query);
      this.showImg = !this.showImg
      if (this.showImg) {
        // debugger
        this.list.totalLikes--;
        // console.log("this.formData.wxName", this.formData.wxName)
        saveOrCancelLikes({
          activityId: query.activityId,
          unionId: this.formData.unionId,
          emplid: query.emplid,
          wxName: this.formData.wxName
        })
      } else {
        this.list.totalLikes++;
        saveOrCancelLikes({
          activityId: query.activityId,
          // unionId: 'oSWTisrBhmQvvsO0q5nFN46USQr4',
          unionId: this.formData.unionId,
          emplid: query.emplid,
          // wxName: '张大展'
          wxName: this.formData.wxName
        })
      }
    }
  },
};
</script>

<style scoped>
.empInfoBox {
  width: 100%;
  min-height: 60px;
  background-color: white;
  display: flex;
  /* padding: 5px; */
  /* overflow: hidden; */
  position: fixed;
  top: 0;
  left: 0;
  border-bottom: 1px solid rgb(223, 220, 220);
  z-index: 998;
  justify-content: space-around;
  align-items: center;
}
.leftBox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatarBox {
  width: 40px;
  height: 40px;
  background-size: 100% 100%;
  border-radius: 50%;
  /* margin-right: 5px; */
  /* margin-top: 5px; */
  /* flex: 1; */
  /* background-color: skyblue; */
}
.empName {
  font-size: 16px;
  font-weight: bold;
  /* margin-bottom: 5px; */
  /* margin-top: 5px; */
  flex: 2;
}
.empCompanyName {
  font-size: 11px;
  flex: 2;
}
.middleBox {
  min-width: 60%;
  overflow: hidden;
  word-break: break-all;
  padding-top: 5px;
  font-size: 12px;
}
.empInfoBox > .rightBox {
  overflow: hidden;
  text-align: center;
}
.wxWorkIcon {
  width: 30px;
  height: 30px;
  background-image: url("../assets/images/wxWorkIcon.png");
  background-size: 100% 100%;
  margin: 0 auto;
}
.showQRcodeMask {
  width: 100%;
  height: 100vh;
  position: fixed;
  background-color: rgba(209, 205, 205, 0.8);
  top: 0;
  left: 0;
  z-index: 999;
}
.qrcodeInfoBox {
  width: 90%;
  padding: 10px;
  margin: 0 auto;

  background-color: #fff;
  margin-top: 50px;
}
.qrcodeEmpInfoBox {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.qrcodeEmpInfoBox .avatarBox {
  width: 40px;
  height: 40px;
}
.qrcodeEmpInfoBox .leftBox,
.qrcodeEmpInfoBox .middleBox {
  /* min-width: 48%; */
}
.qrcodeImg {
  width: 100%;
  overflow: hidden;
}
.qrcodeImg > img {
  display: inline-block;
  width: 100%;
}
.qrcodeText {
  width: 100%;
  text-align: center;
}

.practiceTitle,
.practiceTitle,
.empCompanyName,
.qrcodeText,
.wxWrokText {
  font-size: 12px;
}
.empInfoBox .btn {
  position: absolute;
  right: 0;
  /* top: 70px; */
  top: 580px;
  height: 50px;
}
.empInfoBox .btn .big {
  position: absolute;
  /* left: 220px; */
  right: 0;
  top: 0px;
  display: flex;
  width: 157px;
  height: 50px;
  line-height: 50px;
  font-size: 12px;
  z-index: 9;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  background-color: rgba(249, 249, 249, 0.6);
}
.empInfoBox .btn .big_1 {
  width: 27px;
  height: 50px;
  padding-left: 5px;
  margin-top: -3px;
  font-size: 12px;
}
.empInfoBox .btn .big_1 .shrink {
  width: 27px;
  writing-mode: vertical-lr;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-top: 6px;
}
.empInfoBox .btn .big_1 img {
  display: block;
  margin-top: 3px;
  margin-left: 10px;
  width: 8px;
  height: 8px;
  /* background-color: rgb(175, 76, 76) */
}
.empInfoBox .btn .big_1:hover {
  cursor: pointer;
}
.empInfoBox .btn .big_2 {
  flex: 1;
  display: flex;
  justify-content: space-evenly;
  height: 60px;
}
.empInfoBox .btn .big_2 span {
  font-size: 14px;
  color: rgb(47, 57, 202);
}
.empInfoBox .btn .big_2 .good {
  width: 45px;
  height: 50px;
}
.empInfoBox .btn .big_2 .good img {
  display: block;
  margin-top: 5px;
  margin-left: 10px;
  width: 21px;
  height: 21px;
}
.empInfoBox .btn .big_2 .good .text {
  font-size: 12px;
  margin-left: -4px;
  margin-top: -11px;
  text-align: center;
}
.empInfoBox .btn .small {
  position: absolute;
  /* left: 343px; */
  right: 0;
  top: 0px;
  width: 26px;
  height: 50px;
  background-color: rgba(249, 249, 249, 0.6);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  padding-left: 5px;
  font-size: 12px;
}
.empInfoBox .btn .small .unfold {
  writing-mode: vertical-lr;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.empInfoBox .btn .small img {
  display: block;
  margin-top: 6px;
  margin-left: 4px;
  width: 8px;
  height: 8px;
  /* background-color:blueviolet; */
}
.empInfoBox .btn .small:hover {
  cursor: pointer;
}
</style>